import React, { useState, useEffect } from 'react';
import FriendProfileSidebar from './FriendProfileSidebar/FriendProfileSidebar';
import FriendProfileModal from './FriendProfileModal/FriendProfileModal';
import CompactProfileCard from './CompactProfileCard/CompactProfileCard';
import { useAuth } from "./../../utils/AuthContext/authcontext";


export default function CompactProfile({ isTile, userId = null, onCloseWindow }) {
  const isMobile = window.innerWidth < 768;
  const [viewedUser, setViewedUser] = useState(null);
  const { searchbyUsersId } = useAuth();
  
  useEffect(() => {
      const fetchUserData = async () => {
		const users = await searchbyUsersId(userId);
		setViewedUser(users[0]);
      };
      if(userId != null)fetchUserData();
	  else 
	  {
		setViewedUser(null);
	  }
  }, [userId]);
  
  const handleClose = async () => {
	setViewedUser(null);
	if(onCloseWindow) onCloseWindow(true);
  };
  
  return (
    <>
		{/*viewedUser && (
		  isMobile
			? <FriendProfileSidebar user={viewedUser} onClose={() => handleClose()} />
			: <FriendProfileModal user={viewedUser} onClose={() => handleClose()} />
		)*/}
		{viewedUser && (<CompactProfileCard isTile={isTile} user={viewedUser} onClose={() => handleClose()}/>
		)}
    </>
  );
}
